export default __webpack_public_path__ + "media/images/images_v2/bottom-onglet-c97ba965cf5f386ad79ba223ce3f5970.png";